import { findIndex, propEq, isEmpty } from 'ramda';
import { mapDateFromUI } from '@bridebook/toolbox/src';
import { IDatePickerUI } from '@bridebook/toolbox/src/datepicker/types';
import { IDeps } from '@bridebook/web/lib/types';
import { updateWeddingField } from '@bridebook/web/lib/weddings/actions';
import { initialiseChecklist, reInitialiseChecklist } from '@bridebook/web/lib/checklist/actions';
import './types';

export const tabs = [{ id: 'year-screen' }, { id: 'month-screen' }, { id: 'day-screen' }];

export const tabIndex = (id: string) => findIndex(propEq('id', id), tabs);

export const registerDatePicker = (datePickerUI?: IDatePickerUI | null, activeTab?: string) => ({
  type: 'REGISTER_DATEPICKER',
  payload: {
    datePickerUI,
    activeTab,
  },
});

export const changeTabSuccess = (payload: { tab: string }) => ({
  type: 'DATEPICKER_CHANGE_TAB_SUCCESS',
  payload,
});

export const resetDatepickerDate = (newDateObject: Partial<IDatePickerUI> = {}) => ({
  type: 'RESET_DATEPICKER_DATE',
  payload: { newDateObject },
});

export const changeDatepickerDate = (
  name: string,
  value: string | number | boolean,
  method: string = 'button',
) => ({
  type: 'CHANGE_DATEPICKER_DATE',
  payload: { name, value, method },
});

export const cancelDatepickerEdit = (track: boolean = true) => ({
  type: 'CANCEL_DATEPICKER_EDIT',
  payload: { track },
});

export const startDatepickerDateEdit = (date: IDatePickerUI | null) => ({
  type: 'START_DATEPICKER_DATE_EDIT',
  payload: { date },
});

export const toggleDatePicker = (modalState: boolean = true) => ({
  type: 'TOGGLE_DATEPICKER',
  payload: { modalState },
});

export const tabClickedByUser = () => ({
  type: 'TAB_CLICKED_BY_USER',
});

export const saveWeddingDate =
  (datePickerUI: IDatePickerUI) =>
  ({ dispatch, getState }: IDeps) => {
    const {
      weddings: {
        profile: { date },
      },
      checklist: { initialised },
    } = getState();

    const newDate = mapDateFromUI(datePickerUI);
    dispatch(updateWeddingField('date', { date: newDate }));

    if (date && !isEmpty(date)) {
      if (initialised) {
        dispatch(reInitialiseChecklist());
      }
      dispatch(initialiseChecklist(false));
    }
    dispatch(toggleDatePicker(false));
    return { type: 'SAVE_WEDDING_DATE_THUNK' };
  };
